export const congregationMonthReportConsts = {
  LOAD_REQUEST: '[Congregation Month Report] LOAD_REQUEST',
  LOAD_SUCCESS: '[Congregation Month Report] LOAD_SUCCESS',
  LOAD_FAILURE: '[Congregation Month Report] LOAD_FAILURE',
};
